import { render, staticRenderFns } from "./studentcomment.vue?vue&type=template&id=165f4649&"
import script from "./studentcomment.vue?vue&type=script&lang=js&"
export * from "./studentcomment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\atmolab_server_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('165f4649')) {
      api.createRecord('165f4649', component.options)
    } else {
      api.reload('165f4649', component.options)
    }
    module.hot.accept("./studentcomment.vue?vue&type=template&id=165f4649&", function () {
      api.rerender('165f4649', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/coachmanage/teammanage/component/studentcomment.vue"
export default component.exports